export default __webpack_public_path__ + "static/media/Bonito21Mushroomhead.c8a320ae.xml";